<template>
    <div class="report-builder w-100">
        <el-form id="search" class="px-3 pt-3 pb-2" size="mini" :inline="false">
            <el-form-item class="my-auto">
                <div class="m-0 row">
                    <div class="col-auto px-0">
                        <!-- <el-select placeholder="Filter by BDM" v-model="tenantFilters.bdm" clearable>
                            <el-option
                                v-for="bdm in bdms"
                                :key="bdm.id"
                                :label="bdm.full_name"
                                :value="bdm"
                            ></el-option>
                        </el-select> -->
                        <el-select v-if="isMaster" @change="reportChanged" placeholder="Filter by State" v-model="tenantFilters.state" clearable>
                            <el-option
                                v-for="state in states"
                                :key="state"
                                :label="state"
                                :value="state"
                            ></el-option>
                        </el-select>

                        <el-button
                            v-show="canScheduleReport"
                            :type="_.get(selectedReport, 'schedules', []).length ? 'primary' : 'info'"
                            size="mini"
                            :plain="!_.get(selectedReport, 'schedules', []).length"
                            class="mx-0"
                            style="border-radius: 3px !important; font-size: 13px"
                            @click="scheduleReport = true"
                        >
                            <span><i class="fas fa-bell"></i></span>
                        </el-button>
                        <el-input
                            v-if="selectedReport === false"
                            v-model="reportName"
                            placeholder="New Report Name"
                            style="width: auto; min-width: 500px"
                        ></el-input>
                        <el-button
                            v-show="selectedReport === false"
                            type="primary"
                            style="border-radius: 3px !important; font-size: 13px"
                            @click="saveReport()"
                        >
                            <span>
                                <i class="fas fa-save"></i>
                                <span class="pl-2">Save</span>
                            </span>
                        </el-button>

                        <el-select
                            :key="reports.length"
                            ref="reportSelect"
                            v-if="selectedReport !== false"
                            v-model="selectedReport"
                            :placeholder="loading && !reports.length ? 'Loading Reports...' : 'Select Existing Report'"
                            popper-class="report-builder-popper"
                            style="width: auto; min-width: 500px"
                            value-key="report_key"
                            clearable
                            :filterable="reportSelectFilterable"
                            default-first-option
                            :automatic-dropdown="false"
                            :disabled="loading && !reports.length"
                            @clear="clearReport"
                            @change="loadReport"
                            @visible-change="reportSelectVisibleChange"
                        >
                            <el-option-group v-for="(group, groupIndex) in reportCategories" :key="groupIndex"
                                             :label="group">
                                <el-option
                                    v-for="report in reports.filter((r) =>
                                        group == 'System Reports'
                                            ? r.report_key == 'master-' + r.id
                                            : r.report_key == 'tenant-' + r.id
                                    )"
                                    :key="report.report_key"
                                    :label="report.name"
                                    :value="report"
                                >
                                    <template v-if="_.get(report, 'schedules', []).length">
                                        <span style="float: left">{{ report.name }}</span>
                                        <template
                                            v-if="
                                                _.flatMap(_.get(report, 'schedules', []), ({ users }) =>
                                                    _.map(users, (user) => user.user_id)
                                                ).includes(_.get(Ambition.Globals, 'tenant.user.id'))
                                            "
                                        >
                                            <span style="float: right; font-size: 14px"><i
                                                class="fas fa-bell"></i></span>
                                        </template>
                                        <template v-else>
                                            <span style="float: right; font-size: 14px"><i
                                                class="far fa-bell"></i></span>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span>{{ report.name }}</span>
                                    </template>
                                </el-option>
                            </el-option-group>
                        </el-select>
                        <el-button
                            v-show="selectedReport === false"
                            type="info"
                            size="mini"
                            class="mx-0"
                            style="font-size: 13px"
                            @click="
                                selectedReport = reports.find((r) => r.id == reportId)
                                reportName = _.get(selectedReport, 'name')
                                reportDescription = _.get(selectedReport, 'description')
                            "
                        >
                            <span>
                                <i class="fas fa-times"></i>
                                <span class="pl-2">Cancel</span>
                            </span>
                        </el-button>
                        <el-button
                            v-show="canEditReport"
                            type="warning"
                            size="mini"
                            class="mx-0"
                            style="border-radius: 3px !important; font-size: 13px"
                            @click="showReportSettingsForm"
                        >
                            <span><i class="fas fa-edit"></i></span>
                        </el-button>
                        <el-button
                            v-show="selectedReport !== false && selectedColumns.length"
                            type="primary"
                            size="mini"
                            class="mx-0"
                            style="border-radius: 3px !important; font-size: 13px"
                            @click="
                                selectedReport = false
                                reportName = ''
                                reportDescription = ''
                            "
                        >
                            <span><i class="fas fa-save"></i></span>
                        </el-button>
                        <el-button
                            v-show="canEditReport"
                            type="danger"
                            size="mini"
                            class="mx-0"
                            style="font-size: 13px"
                            @click="deleteReport"
                        >
                            <span><i class="fas fa-trash-alt"></i></span>
                        </el-button>
                    </div>
                    <div class="pl-1 col">
                        <el-select
                            v-model="dateField"
                            placeholder="Select"
                            popper-class="report-builder-select-popper"
                            :automatic-dropdown="false"
                            :disabled="loading && !reports.length"
                            @change="reportChanged"
                        >
                            <el-option
                                label="Activity Date"
                                value="history.activity"
                                :disabled="reportContainsGroupedDate"
                            ></el-option>
                            <el-option label="Lead Date" value="history.lead"></el-option>
                            <el-option label="First Assigned Date" value="firstAssigned.date"></el-option>
                            <el-option label="Submission Date" value="history.submittedToLender"></el-option>
                            <el-option label="Approval Date" value="history.conditionallyApproved"></el-option>
                            <el-option label="Option Date" value="history.optionsSent"></el-option>
                            <el-option label="Remittance Date" value="settlement.remittanceDate"></el-option>
                            <el-option label="Completed Date" value="settlement.completedDate"></el-option>
                            <el-option label="Closed Date" value="history.closed"></el-option>
                            <el-option label="Conditioning Received Date" value="history.conditioningReceived"></el-option>
                            <el-option label="Signed Privacy Date" value="privacyConsentDate"></el-option>
                            <el-option label="Term End Date" value="loan.finance.termEndDate"></el-option>
                            <el-option label="Referrer Created Date" value="referrer.create_date"></el-option>
                            <el-option label="Last Assigned Date" value="history.assigned"></el-option>
                        </el-select>
                        <el-select
                            v-model="dateRangeSelect"
                            clearable
                            placeholder="Date Range"
                            popper-class="report-builder-select-popper"
                            :automatic-dropdown="false"
                            :disabled="loading && !reports.length"
                            @change="reportChanged"
                        >
                            <el-option label="Custom Range" value="Custom Range"></el-option>
                            <el-option label="Today" value="Today"></el-option>
                            <el-option label="Yesterday" value="Yesterday"></el-option>
                            <el-option label="This Week" value="This Week"></el-option>
                            <el-option label="This Month" value="This Month"></el-option>
                            <el-option label="This Quarter" value="This Quarter"></el-option>
                            <el-option label="This Year" value="This Year"></el-option>
                            <el-option label="Last Week" value="Last Week"></el-option>
                            <el-option label="Last Month" value="Last Month"></el-option>
                            <el-option label="This Month Last Year" value="This Month Last Year"></el-option>
                            <el-option label="This Month 2 Years Ago" value="This Month 2 Years Ago"></el-option>
                            <el-option label="This Month 3 Years Ago" value="This Month 3 Years Ago"></el-option>
                            <el-option label="This Month 4 Years Ago" value="This Month 4 Years Ago"></el-option>
                            <el-option label="Last Quarter" value="Last Quarter"></el-option>
                            <el-option label="Last Year" value="Last Year"></el-option>
                            <el-option label="Last 30 Days" value="Last 30 Days"></el-option>

                            <!-- future dates for term end date filtering -->
                            <el-option v-if="dateField == 'loan.finance.termEndDate'" label="Next 30 Days" value="Next 30 Days"></el-option>
                            <el-option v-if="dateField == 'loan.finance.termEndDate'" label="Next 90 Days" value="Next 90 Days"></el-option>
                            <el-option v-if="dateField == 'loan.finance.termEndDate'" label="Next 365 Days" value="Next 365 Days"></el-option>
                        </el-select>
                        <el-date-picker
                            v-show="dateRangeSelect == 'Custom Range'"
                            v-model="dateRange"
                            name="date-range"
                            width="250"
                            format="dd MMM yyyy"
                            :value-format="this.dateField == 'loan.finance.termEndDate' ? 'yyyy-MM-dd' : ''"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :picker-options="{
                                firstDayOfWeek: 1,
                                disabledDate: (date) => {
                                    if (this.dateField == 'loan.finance.termEndDate') return;
                                    return date > $moment.now()
                                },
                            }"
                            :unlink-panels="true"
                            clearable
                            @change="reportChanged"
                        ></el-date-picker>
                        <el-button
                            v-show="selectedColumns.length"
                            type="success"
                            size="mini"
                            icon="el-icon-refresh"
                            style="font-size: 13px"
                            :loading="loading"
                            @click="reportChanged"
                        ></el-button>
                        <el-button
                            v-show="selectedColumns.length && checkExportPermissions()"
                            type="primary"
                            size="mini"
                            class="ml-0"
                            style="border-radius: 3px !important; font-size: 13px"
                            @click="exportModal = true"
                        >
                            <span v-if="!exporting"><i class="fas fa-file-excel"></i></span>
                            <span class="pl-1">Export</span>
                        </el-button>
                        <!--                        <el-button-->
                        <!--                            v-show="selectedColumns.length"-->
                        <!--                            type="primary"-->
                        <!--                            size="mini"-->
                        <!--                            class="ml-0"-->
                        <!--                            style="border-radius: 3px !important; font-size: 13px"-->
                        <!--                            :loading="exporting"-->
                        <!--                            @click="exportReport"-->
                        <!--                            @click="exportModal = true"-->
                        <!--                        >-->
                        <!--                            <span v-if="!exporting"><i class="fas fa-file-excel"></i></span> <span-->
                        <!--                            class="pl-1">Export</span>-->
                        <!--                        </el-button>-->
                        <el-checkbox
                            v-show="selectedColumns.length"
                            v-model="excludeGst"
                            class="pl-2 my-0 exclude-gst"
                            @change="reportChanged"
                        >
                            Exclude GST
                        </el-checkbox>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="my-auto">
                <div class="m-0 mt-2 mb-1 row">
                    <div class="p-0 col" style="padding-right: 3px !important; color: #606266">
                        <el-cascader
                            v-model="optionsSelected"
                            :options="options"
                            :show-all-levels="false"
                            :props="{ multiple: true, checkStrictly: false, emitPath: false, expandTrigger: 'hover' }"
                            :disabled="loading && !reports.length"
                            popper-class="report-columns-cascader"
                            placeholder="Build New Report"
                            class="w-100"
                            clearable
                            @change="selectedColumnsChange"
                            @clear="handleResize"
                            @remove-tag="fieldRemoved"
                        ></el-cascader>
                    </div>
                </div>
            </el-form-item>
        </el-form>

        <el-table
            v-if="filterColumns && filterColumns.length"
            :data="[]"
            border
            class="report-builder-table filters"
            style="max-height: 59px; border: none; background: transparent"
            empty-text=" "
            :fit="false"
            @header-dragend="headerResize"
        >
            <el-table-column
                v-for="(column, index) in filterColumns"
                :key="`${index}-${column.prop}`"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :align="column.align"
                :header-align="column.headerAlign"
            >
                <template slot-scope="scope" slot="header">
                    <el-row class="header-handle">
                        <el-col class="pt-2 cell">
                            <span>{{ scope.column.label }}</span>
                        </el-col>
                    </el-row>
                    <el-row v-show="editMode" class="header-filter">
                        <el-col>
                            <el-select
                                v-if="column.aggregate == 'filter'"
                                :value="filterColumns[index].searchTerm"
                                multiple
                                collapse-tags
                                default-first-option
                                filterable
                                clearable
                                size="mini"
                                class="w-100 header-filter-select"
                                popper-class="header-filter-popper"
                                style="font-weight: 300; text-transform: capitalize: font-size: 10px"
                                placeholder="Filter"
                                :loading="filterLoading"
                                @change="(val) => filterSelectChange(val, scope, column)"
                                @clear="reportChanged"
                                @remove-tag="reportChanged"
                                @visible-change="(visible) => filterSelectVisibleChange(visible, column)"
                                @focus="
                                    (event) =>
                                        _.get(filters, column.prop, false)
                                            ? _.get(filters, column.prop)
                                            : getFilterValues(event, column)
                                "
                            >
                                <el-radio-group
                                    v-model="column.filterOperator"
                                    size="mini"
                                    class="px-3 py-2 header-filter-operator"
                                    @change="(val) => filterOperatorChange(val, column)"
                                >
                                    <el-radio-button label="=">Includes</el-radio-button>
                                    <el-radio-button label="!=">Excludes</el-radio-button>
                                </el-radio-group>
                                <el-option
                                    v-for="(value, index) in _.get(filters, column.prop, [])"
                                    :key="index"
                                    :label="value || 'Blank'"
                                    :value="value"
                                ></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>

        <el-table
            ref="reportBuilderTable"
            :data="tableData"
            show-summary
            border
            class="report-builder-table"
            header-row-class-name="dragula-container"
            empty-text=" "
            :height="getMaxHeight()"
            @header-dragend="headerResize"
            :default-sort="{ sortField, sortOrder }"
            @sort-change="sortMethod"
            :sum-text="`Records ${from} to ${to} of ${total}`"
            :summary-method="getSummaries"
            :fit="false"
        >
            <el-table-column
                v-for="(column, index) in reportColumns"
                :key="`${index}-${column.prop}`"
                :prop="column.prop"
                :label="column.label"
                :formatter="column.formatter"
                :width="column.width"
                :align="column.align"
                :header-align="column.headerAlign"
                :fixed="
                    selectedColumns.length < 35 &&
                    selectedColumns.findIndex((col) => col == column.label) < 2 &&
                    reportColumns.reduce((a, b) => a + b['width'], 0) > $refs.reportBuilderTable.$el.offsetWidth
                "
                :sortable="to == total && !column.orderBy && !column.orderDateFormat ? true : 'custom'"
                show-overflow-tooltip
            >
                <template slot-scope="scope" slot="header">
                    <el-row class="header-handle">
                        <el-col class="pt-2 cell">
                            <span>{{ scope.column.label }}</span>
                        </el-col>
                    </el-row>
                    <el-row v-show="editMode" class="header-filter">
                        <el-col>
                            <el-select
                                v-if="column.aggregate == 'group'"
                                :value="reportColumns[index].searchTerm"
                                multiple
                                collapse-tags
                                default-first-option
                                filterable
                                clearable
                                size="mini"
                                class="w-100 header-filter-select"
                                popper-class="header-filter-popper"
                                style="font-weight: 300; text-transform: capitalize: font-size: 10px"
                                placeholder="Filter"
                                :loading="filterLoading"
                                @change="(val) => filterSelectChange(val, scope, column)"
                                @clear="reportChanged"
                                @remove-tag="reportChanged"
                                @visible-change="(visible) => filterSelectVisibleChange(visible, column)"
                                @focus="
                                    (event) =>
                                        _.get(filters, column.prop, false)
                                            ? _.get(filters, column.prop)
                                            : getFilterValues(event, column)
                                "
                            >
                                <el-radio-group
                                    v-model="column.filterOperator"
                                    size="mini"
                                    class="px-3 py-2 header-filter-operator"
                                    @change="(val) => filterOperatorChange(val, column)"
                                >
                                    <el-radio-button label="=">Includes</el-radio-button>
                                    <el-radio-button label="!=">Excludes</el-radio-button>
                                </el-radio-group>
                                <el-option
                                    v-for="(value, index) in _.get(filters, column.prop, [])"
                                    :key="index"
                                    :label="value || 'Blank'"
                                    :value="value"
                                ></el-option>
                            </el-select>
                            <el-input
                                v-else-if="!['group', 'primary'].includes(column.aggregate)"
                                size="mini"
                                class="w-100 font-10"
                                :readonly="true"
                                :placeholder="_.startCase(column.aggregate)"
                                @click.native="(e) => e.stopPropagation()"
                            ></el-input>
                            <el-input
                                v-else
                                :value="reportColumns[index].searchTerm"
                                clearable
                                size="mini"
                                class="w-100 font-10"
                                placeholder="Filter"
                                @input="(val) => filterSelectChange(val, scope, column)"
                                @keyup.enter.native="reportChanged"
                                @clear="reportChanged"
                                @click.native="(e) => e.stopPropagation()"
                            ></el-input>
                        </el-col>
                    </el-row>
                </template>
                <template slot-scope="scope">
                    <el-link
                        v-if="scope.column.label == 'App Id' && scope.row[scope.column.label]"
                        type="default"
                        icon="el-icon-link"
                        class="d-inline"
                        :href="scope.row.Url"
                        target="_blank"
                    >
                        {{ scope.row["App Id"] }}
                    </el-link>
                    <span v-else>
                        {{
                            scope.column.formatter
                                ? scope.column.formatter(scope.row, scope.column, scope.row[scope.column.label], scope.$index)
                                : scope.row[scope.column.label]
                        }}
                    </span>
                </template>
            </el-table-column>
            <infinite-loading
                slot="append"
                ref="infiniteLoading"
                @infinite="infiniteHandler"
                :identifier="identifier"
                :infinite-scroll-immediate="false"
                spinner="waveDots"
                force-use-infinite-wrapper=".el-table__body-wrapper"
            >
                <span slot="no-more"></span>
                <span slot="no-results"></span>
            </infinite-loading>
        </el-table>

        <x-modal
            :wWidth="593"
            v-if="scheduleReport"
            @cancel="scheduleReport = false"
            @close="scheduleReport = false"
            @ok="saveSchedule"
            @okSecondary="deleteSchedule"
            :draggable="true"
            :resizable="true"
            okText="Save Schedule"
            okSecondaryText="Delete Schedule"
            okSecondaryType="danger"
            :hideOkSecondary="!_.get(selectedReport, 'schedules', []).length"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Schedule Report</div>

            <el-form ref="roleForm" inline>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <recurrence-editor v-model="recurrenceSettings"></recurrence-editor>
                    </el-col>
                </el-row>
            </el-form>
        </x-modal>

        <x-modal
            :wWidth="593"
            v-if="canEditReport && editReportModal"
            @cancel="hideReportSettingsForm"
            @close="hideReportSettingsForm"
            @ok="saveReportSettings"
            @okSecondary="deleteReport"
            :draggable="true"
            :resizable="true"
            okText="Save Settings"
            okSecondaryText="Delete Report"
            okSecondaryType="danger"
            :hideOkSecondary="false"
            :loading="loadingReportSettings"
            :okDisabled="loadingReportSettings"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Edit Report Settings</div>

            <div class="report-settings-editor-container">
                <el-form
                    ref="reportSettingsForm"
                    :model="reportSettingsForm"
                    :rules="reportSettingsFormRules"
                    label-position="top"
                    size="small"
                >
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="Name" prop="name">
                                <el-input v-model="reportSettingsForm.name" placeholder="Name"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="Description" prop="description">
                                <el-input v-model="reportSettingsForm.description" placeholder="Description"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="isAdminOrManager" :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="Hubspot" prop="hsEnabled">
                                <el-checkbox v-model="reportSettingsForm.hsEnabled">Use for HubSpot</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Owner" prop="ownerId">
                                <el-select
                                    v-model="reportSettingsForm.ownerId"
                                    placeholder="Owner"
                                    popper-class="report-settings-select-popper"
                                    filterable
                                    class="w-100"
                                >
                                    <el-option-group
                                        v-if="filterReportUsers('administrator', false).length"
                                        label="Administrators"
                                    >
                                        <template v-for="user in filterReportUsers('administrator', false)">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                    <el-option-group v-if="filterReportUsers('manager', false).length" label="Managers">
                                        <template v-for="user in filterReportUsers('manager', false)">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                    <el-option-group v-if="filterReportUsers('broker', false).length" label="Brokers">
                                        <template v-for="user in filterReportUsers('broker', false)">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="isAdminOrManager" :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="Role Access" prop="roles">
                                <div class="d-block">
                                    <el-checkbox-group v-model="reportSettingsForm.roles" size="small">
                                        <el-checkbox-button
                                            v-for="role in reportRoles"
                                            :label="role.value"
                                            :value="role.value"
                                            :key="role.value"
                                        >
                                            {{ role.plural }}
                                        </el-checkbox-button>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="!_.isEmpty(currentUser.teams) && isAdminOrManager" :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="Team Access" prop="teamIds">
                                <el-select
                                    v-model="reportSettingsForm.teamIds"
                                    placeholder="Teams"
                                    popper-class="report-settings-select-popper"
                                    filterable
                                    clearable
                                    multiple
                                    @remove-tag="removeTeamTag"
                                    class="w-100"
                                >
                                    <template v-for="team in teams">
                                        <el-option
                                            :class="{ 'd-none': !_.find(currentUser.teams, { id: team.id }) }"
                                            :key="team.id"
                                            :label="team.name"
                                            :value="team.id"
                                            :disabled="!_.find(currentUser.teams, { id: team.id })"
                                        ></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="!_.isEmpty(reportUsers) && isAdminOrManager" :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="User Access" prop="userIds">
                                <el-select
                                    v-model="reportSettingsForm.userIds"
                                    :placeholder="userAccessPlaceholder"
                                    popper-class="report-settings-select-popper"
                                    filterable
                                    clearable
                                    multiple
                                    class="w-100"
                                >
                                    <el-option-group v-if="filterReportUsers('administrator').length"
                                                     label="Administrators">
                                        <template v-for="user in filterReportUsers('administrator')">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                    <el-option-group v-if="filterReportUsers('manager').length" label="Managers">
                                        <template v-for="user in filterReportUsers('manager')">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                    <el-option-group v-if="filterReportUsers('broker').length" label="Brokers">
                                        <template v-for="user in filterReportUsers('broker')">
                                            <el-option
                                                :key="user.id"
                                                :label="user.full_name"
                                                :value="user.id"
                                                class="pl-4 pr-5 font-12"
                                            ></el-option>
                                        </template>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </x-modal>

        <el-dialog title="Select Export Type" :visible.sync="exportModal" width="30%" :before-close="exportModalClose">
            <div class="fin-flex fin-space-x-4 fin-justify-center fin-items-center">
                <el-button
                    v-show="selectedColumns.length"
                    class="fin-rounded fin-px-5 fin-py-5 fin:hover:bg-blue-600"
                    :loading="exporting"
                    @click="exportTypeBtn('csv')"
                >
                    <span v-if="!exporting"><i class="fas fa-file-excel"></i></span>
                    <span class="pl-1">.CSV</span>
                </el-button>

                <el-button
                    v-show="selectedColumns.length"
                    class="fin-rounded fin-px-5 fin-py-5 fin:hover:bg-blue-600"
                    :loading="exporting"
                    @click="exportTypeBtn('xlsx')"
                >
                    <span v-if="!exporting"><i class="fas fa-file-excel"></i></span>
                    <span class="pl-1">.XLSX</span>
                </el-button>
                <template v-if="isSuperAdmin">
                    <el-button
                        v-show="selectedColumns.length"
                        class="fin-rounded fin-px-5 fin-py-5 fin:hover:bg-blue-600"
                        :loading="exporting"
                        @click="exportTypeBtn('csvDocs')"
                    >
                        <span v-if="!exporting"><i class="fas fa-file-excel"></i></span>
                        <span class="pl-1">.CSV &amp; Docs</span>
                    </el-button>

                    <el-button
                        v-show="selectedColumns.length"
                        class="fin-rounded fin-px-5 fin-py-5 fin:hover:bg-blue-600"
                        :loading="exporting"
                        @click="exportTypeBtn('xlsxDocs')"
                    >
                        <span v-if="!exporting"><i class="fas fa-file-excel"></i></span>
                        <span class="pl-1">.XLSX &amp; Docs</span>
                    </el-button>
                </template>
            </div>
            <div class="fin-mt-5 fin-flex fin-space-x-4 fin-justify-center fin-items-center">
                <el-checkbox v-model="showSummary">Show Summary Row?</el-checkbox>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dragula from "dragula"
import RecurrenceEditor from "@tenant/ambition/components/reports/RecurrenceEditor"

export default {
    name: "ReportBuilder",
    props: {
        container: {
            required: false,
            type: String,
            default: "el-main",
        },
    },
    components: {
        RecurrenceEditor,
    },
    data() {
        return {
            showSummary: true,
            exportModal: false,
            exportType: "xlsx",
            scheduleReport: false,
            recurrenceSettings: null,
            defaultRecurrenceSettings: {
                repeatOption: {
                    type: "every_week",
                    everyWeekPicker: ["1", "2", "3", "4", "5", "6", "7"],
                },
                repeatAt: "10:00",
                scheduleUsers: [],
                showSummary: true
            },
            editReportModal: false,
            reports: [],
            reportId: null,
            selectedReport: null,
            reportName: null,
            reportDescription: null,
            filters: [],
            filterLoading: true,
            editMode: true,
            collapseTags: true,
            loading: false,
            exporting: false,
            sortField: null,
            sortOrder: null,
            reportSelectFilterable: true,
            filterSelectDirty: false,
            filterSelectVisible: false,
            identifier: +new Date(),
            state: null,
            page: 1,
            perPage: 50,
            from: 0,
            to: 0,
            total: null,
            drake: null,
            dateField: "history.activity",
            dateRange: null,
            dateRangeSelect: "This Month",
            excludeGst: false,
            columns: [],
            summary: null,
            states: [
                'NSW', 'QLD', 'SA', 'VIC', 'NT', 'TAS', 'WA', 'ACT'
            ],
            bdms: [],
            tenantFilters: {},
            tableData: [],
            formatter: {
                string: (row, col, cell, index) => (cell !== "null" ? cell : null),
                percentage: (row, col, cell, index) => (parseFloat(cell) > 0 ? parseFloat(cell * 100).toFixed(2) + "%" : ""),
                currency: (row, col, cell, index) =>
                    cell
                        ? new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(cell)
                        : "",
                number: (row, col, cell, index) =>
                    cell
                        ? new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        }).format(cell)
                        : "",
            },
            orderedColumns: [],
            options: [],
            optionsSelected: [],
            loadingReportSettings: false,
            reportSettingsForm: {
                name: "",
                hsEnabled: false,
                description: "",
                ownerId: null,
                teamIds: [],
                userIds: [],
                roles: [],
            },
            reportSettingsFormRules: {
                name: [{required: true, message: "Report name is required", trigger: "change"}],
                description: [{required: false, trigger: "change"}],
                ownerId: [{required: true, message: "Report owner is required", trigger: "change"}],
                roles: [{required: true, message: "Atleast one role must be selected", trigger: "change"}],
                teamIds: [{required: false, trigger: "change"}],
                userIds: [{required: false, trigger: "change"}],
            },
            reportUsers: [],
            reportRoles: [
                {
                    label: "Administrator",
                    plural: "Administrators",
                    value: "administrator",
                },
                {
                    label: "Manager",
                    plural: "Managers",
                    value: "manager",
                },
                {
                    label: "Broker",
                    plural: "Brokers",
                    value: "broker",
                },
            ],
            customFields: []
        }
    },
    computed: {
        totalApps() {
            return this.total
        },
        columnGroups() {

            let columnGroups = [
                {
                    name: "Business Dimensions",
                    fields: ["Year", "Month", "Date", "Tenant", "Team", "Broker", "First Assigned Broker", "Support", "Categories"],
                },
                {
                    name: "Application Dimensions",
                    fields: [
                        "App Id",
                        "Stage",
                        "Status",
                        "Close Reason",
                        "Lender",
                        "App Type",
                        "Loan Type",
                        "Loan",
                        "Loan Tier",
                        "Term",
                        "Min Rate",
                        "Max Rate",
                        "Writing Rate",
                        "Lender App Id",
                        "Lender Contract No",
                        "Lead Score",
                        "Most Recent Note",
                        "Training Lead",
                        "Amount To Finance",
                        "Business Name",
                    ],
                },
                {
                    name: "Asset Dimensions",
                    fields: [
                        "Asset Type",
                        "New/Used",
                        "Asset Year",
                        "Asset Expected Delivery Date",
                        "Asset Make",
                        "Asset Model",
                        "Asset Description",
                        "Asset NVIC",
                        "Asset VIN",
                        "Asset Stock Number",
                        "Asset Cost",
                        "Asset Odometer",
                        "Asset Rego",
                        "Avg Asset Cost",
                        "Asset Valuation",
                        "Dealership",
                        "Dealership Email",
                        "Dealership Phone",
                        "Seller Type",
                        "Seller Contact",
                        "Seller Email",
                        "Seller Phone",
                        "Seller Mobile",
                    ],
                },
                {
                    name: "Source Dimensions",
                    fields: [
                        "Referrer",
                        "Referrer Id",
                        "Referrer Group",
                        "Referrer State",
                        "Referrer Contact",
                        "Referrer Contact Id",
                        "Incoming Referrer",
                        "Referrer Voucher",
                        "Lead Type",
                        "Lead Source",
                        "Lead Source Details",
                        "Campaign Name",
                        "Campaign Content",
                        "Campaign Medium",
                        "Campaign Source",
                        "Campaign GCLID",
                        "Campaign GBRAID",
                        "Campaign ADSETNAME",
                        "Campaign ADNMAE",
                        "Campaign PLACEMENT",
                        "Campaign KEYWORD",
                        "Campaign MATCHTYPE",
                        "Campaign DEVICE",
                        "CC Lead Source",
                        "CC Campaign Name",
                        "CC Campaign Medium",
                        "CC Campaign GCLID",
                        "CC Campaign ADSETNAME",
                        "CC Campaign ADNMAE",
                        "CC Campaign PLACEMENT",
                        "CC Campaign KEYWORD",
                        "CC Campaign MATCHTYPE",
                        "CC Campaign DEVICE",
                    ],
                },
                {
                    name: "Applicant Dimensions",
                    fields: [
                        "Applicant Id",
                        "Applicant Name",
                        "Applicant Title",
                        "Applicant First Name",
                        "Applicant Last Name",
                        "Applicant Gender",
                        "Applicant Marital Status",
                        "Applicant Dependents",
                        "Applicant DOB",
                        "Applicant Opt Out",
                        "Applicant Address",
                        "Applicant Street",
                        "Applicant City",
                        "Applicant State",
                        "Applicant Postcode",
                        "Applicant Mortgage Financier",
                        "Applicant Mortgage Rate",
                        "Employment Status",
                        "Employment Type",
                        "Monthly Employment Net Income",
                        "Residentital Status",
                        "Residency Status",
                        "Is Asset Backed",
                        "Has Investment Property",
                        "Properties",
                        "Properties Value",
                        "Mortgages",
                        "Mortgaged Value",
                        "Mortgaged Balance",
                        "Credit Cards",
                        "Credit Cards Balance",
                        "Credit Cards Limit",
                        "Personal Loans",
                        "Personal Loans Balance",
                        "Applicant Has CRA",
                        "Applicant CRA Comp",
                        "Applicant CRA Neg 2_0",
                        "Applicant CRA Neg 1_1",
                        "Applicant CRA Onescore",
                        "Applicant Total Secured Mortgaged Vehicle Loans",
                        "Applicant Balance Secured Mortgaged Vehicle Loans",
                        "Business Name",
                        "Business Type",
                        "Applicant 2 Id",
                        "Applicant 2 Name",
                        "Applicant 2 Title",
                        "Applicant 2 First Name",
                        "Applicant 2 Last Name",
                        "Applicant 2 Gender",
                        "Applicant 2 Marital Status",
                        "Applicant 2 Dependents",
                        "Applicant 2 Opt Out",
                        "Applicant 2 Has CRA",
                        "Applicant 2 CRA Comp",
                        "Applicant 2 CRA Neg 2_0",
                        "Applicant 2 CRA Neg 1_1",
                        "Applicant 2 CRA Onescore",
                        "Applicant 2 Total Secured Mortgaged Vehicle Loans",
                        "Applicant 2 Balance Secured Mortgaged Vehicle Loans"
                    ],
                },
                {
                    name: "Customer Review",
                    fields: [
                        "Send Review Request",
                        "No Review Request Reason"
                    ],
                },
                {
                    name: "HEM Dimensions",
                    fields: [
                        "HEM Status",
                        "HEM Benchmark",
                        "HEM Living Status",
                        "HEM Household Income Range",
                        "HEM Location",
                        "HEM Calculation Type",
                        "HEM Reason",
                        "HEM Related Expenses Total",
                        "Other Monthly Expenses Total",
                        "HEM Available Monthly Surplus",
                    ],
                },
                {
                    name: "Insurance Dimensions",
                    fields: [
                        "Comp Provider",
                        "Comp Product",
                        "Comprehensive",
                        "Comp Premium",
                        "Comp Commission",
                        "Comp Frequency",
                        "Comp Policy Number",
                        "Gap Provider",
                        "Gap Product",
                        "Gap",
                        "Gap Premium",
                        "Gap Commission",
                        "Gap Term",
                        "Gap Policy Number",
                        "Wty Provider",
                        "Wty Product",
                        "Warranties",
                        "Wty Premium",
                        "Wty Commission",
                        "Wty Term",
                        "Wty Policy Number",
                        "Cci Provider",
                        "Cci Product",
                        "Cci",
                        "Cci Premium",
                        "Cci Commission",
                        "Cci Term",
                        "Cci Policy Number",
                    ],
                },
                {
                    name: "Date Dimensions",
                    fields: [
                        "Activity Date",
                        "Lead Date",
                        "Referrer Created Date",
                        "First Call Time",
                        "First Assigned Date",
                        "Assigned Date",
                        "App Date",
                        "Submission Date",
                        "Approval Date",
                        "Option Date",
                        "Remittance Date",
                        "Completed Date",
                        "Closed Date",
                        "Signed Privacy Date",
                        "Conditioning Received Date",
                        "Signed Privacy Date",
                        "Term End Date"
                    ],
                },
                {
                    name: "Metrics",
                    fields: [
                        "Leads",
                        "Valid Leads",
                        "Junk",
                        "No Contact",
                        "Open",
                        "Closed",
                        "Apps",
                        "IsApi",
                        "Approvals",
                        "Options",
                        "Settled",
                        "Ins Deals",
                        "NAF",
                        "Balloon",
                        "Volume",
                        "Commission",
                        "Insurances",
                        "DOF",
                        "Fin Comms",
                        "Ins Comms",
                        "Incoming Referrer Amount",
                        "Outgoing Referrer Amount",
                        "Outgoing Voucher Amount",
                        "Other Deal Costs",
                    ],
                },
                {
                    name: "Formulas",
                    fields: [
                        "Open %",
                        "Closed %",
                        "No Contact %",
                        "Apps %",
                        "Approvals %",
                        "Options %",
                        "Settled %",
                        "Avg NAF",
                        "Avg Comm",
                        "Avg DOF",
                    ],
                },
                {
                    name: "Filters",
                    fields: [
                        "Tenant Filter",
                        "Team Filter",
                        "Broker Filter",
                        "Support Filter",
                        "Stage Filter",
                        "Status Filter",
                        "Close Reason Filter",
                        "Lender Filter",
                        "App Type Filter",
                        "Loan Type Filter",
                        "Asset Type Filter",
                        "Seller Type Filter",
                        "Dealership Filter",
                        "Referrer Filter",
                        "Lead Type Filter",
                        "Lead Source Filter",
                        "Asset Backed Filter",
                    ],
                },
            ];

            if (this.isTenant && Ambition.hasRoleOrPermission("report builder export") ||
                this.isTenant && Ambition.hasRoleOrPermission("administrator") ||
                this.isTenant && Ambition.hasRoleOrPermission("manager") ||
                !this.isTenant) {
                // Add contact fields to Applicant Dimensions
                columnGroups[_.findIndex(columnGroups, ['name', 'Applicant Dimensions'])].fields.unshift( ...[
                    "Applicant Email",
                    "Applicant Mobile",
                    "Applicant 2 Email",
                    "Applicant 2 Mobile",
                ])
            }

            return columnGroups;
        },
        ajax() {
            if (this.isMaster) {
                return this.$admin
            } else {
                return this.$tenant
            }
        },
        selectedColumns: {
            // getter
            get: function () {
                let selectedColumns = this.optionsSelected
                if (this.orderedColumns.length) {
                    let newColumns = _.difference(this.optionsSelected, this.orderedColumns)
                    this.orderedColumns = _.concat(_.intersection(this.orderedColumns, this.optionsSelected), newColumns)
                    return this.orderedColumns
                }
                return selectedColumns
            },
            // setter
            set: function (newValue) {
                if (this.orderedColumns.length) {
                    let newColumns = _.difference(this.optionsSelected, this.orderedColumns)
                    this.orderedColumns = _.concat(_.intersection(this.orderedColumns, this.optionsSelected), newColumns)
                    // this.optionsSelected = _.intersection(this.options.flatMap((group) => group.children).map(c => c.label), this.optionsSelected);
                } else {
                    this.optionsSelected = newValue // _.intersection(this.options.flatMap((group) => group.children).map(c => c.label), newValue);
                }
            },
        },
        reportCategories() {
            return ["System Reports", "Custom Reports"]
        },
        isTenant() {
            return !this.isMaster
        },
        isMaster() {
            return _.has(window, "MasterGlobals")
        },
        isAdminOrManager() {
            if (this.isTenant) return Ambition.hasRoleOrPermission("administrator") || Ambition.hasRoleOrPermission("manager")
            else return true // @todo: permission checks
        },
        isAdmin() {
            return this.isTenant && Ambition.hasRoleOrPermission("administrator")
        },
        isSuperAdmin() {
            return this.isTenant && Ambition.hasRoleOrPermission("super administrator")
        },
        isMasterReport() {
            return this.selectedReport && !!this.selectedReport.is_master_report
        },
        isSystemReport() {
            return this.selectedReport && this.selectedReport.report_key == "master-" + this.selectedReport.id
        },
        isTenantReport() {
            return this.selectedReport && this.selectedReport.report_key == "tenant-" + this.selectedReport.id
        },
        isReportOwner() {
            return this.isTenant && _.get(Ambition, "Globals.tenant.userId") == _.get(this.selectedReport, "owner.id")
        },
        hasReportOwner() {
            return !!_.get(this.selectedReport, "owner.id")
        },
        canEditReport() {
            if (!this.selectedReport) return false

            if (this.isMaster) return true

            if (this.isSystemReport) return false

            if (this.isReportOwner) return true

            if (this.isAdmin) return true

            if (!this.hasReportOwner && this.isAdminOrManager) return true

            return false
        },
        canScheduleReport() {
            if (!this.selectedReport) return false

            if (this.isMaster && this.isMasterReport && this.isAdminOrManager) return true

            if (this.isTenantReport && this.isAdminOrManager) return true

            return false
        },
        reportColumns() {
            return this.columns
                .filter((col) => this.selectedColumns.includes(col.prop) && col.aggregate != "filter")
                .sort((a, b) => this.selectedColumns.indexOf(a.prop) - this.selectedColumns.indexOf(b.prop))
        },
        filterColumns() {
            return this.columns
                .filter((col) => this.selectedColumns.includes(col.prop) && col.aggregate == "filter")
                .sort((a, b) => this.selectedColumns.indexOf(a.prop) - this.selectedColumns.indexOf(b.prop))
        },
        reportContainsGroupedDate() {
            return !!this.columns.filter(
                (col) =>
                    this.selectedColumns.includes(col.prop) &&
                    col.aggregate == "group" &&
                    col.dateFormat &&
                    !_.get(col, "fixedDate", false)
            ).length
        },
        currentUser() {
            return Ambition.Globals.tenant.user
        },
        teams() {
            return _.orderBy(Ambition.Globals.tenant.teams, ["name"])
        },
        userAccessPlaceholder() {
            const userCount = this.filterReportUsers("all").length
            const userLabel = userCount === 1 ? "User" : "Users"
            return userCount + " " + userLabel
        },
    },
    watch: {
        editMode() {
            this.handleResize()
        },
        collapseTags() {
            this.handleResize()
        },
        loading(val) {
            if (val) {
                $("body").css("cursor", "progress")
            } else {
                $("body").css("cursor", "default")
            }
        },
    },
    created() {
    },
    mounted() {
        this.getData(this.$refs.infiniteLoading.stateChanger)

        this.drake = dragula({
            isContainer: (el) => el.classList.contains("dragula-container"),
            invalid: (el) => el.style.cursor == "col-resize" || el.style.cursor == "header-filter",
            accepts: (el, target, source, sibling) => {
                if (_.get(el, "classList.0") == _.get(sibling, "classList.0")) {
                    let columnId = _.get(el, "classList.0")
                    if (
                        columnId &&
                        el.classList.contains("is-leaf") &&
                        !$(target).closest(".el-table__fixed-header-wrapper").length
                    ) {
                        $("." + columnId + ".is-leaf.is-sortable.is-hidden").addClass("gu-hide")
                    } else {
                        $("." + columnId + ".is-leaf.is-sortable.is-hidden").removeClass("gu-hide")
                    }
                }
                return true
            },
            revertOnSpill: true,
        })
        this.drake.on("drop", this.onDragDrop)

        window.addEventListener("resize", this.handleResize)
        this.handleResize()
        this.setFieldsScrollable()
    },
    beforeDestroy() {
        if (this.drake) {
            this.drake.destroy()
        }
    },
    methods: {
        checkExportPermissions() {
            return  this.isTenant && Ambition.hasRoleOrPermission("report builder export") ||
                    this.isTenant && Ambition.hasRoleOrPermission("administrator") ||
                    this.isTenant && Ambition.hasRoleOrPermission("manager") ||
                    !this.isTenant
        },
        exportTypeBtn(exportType) {
            this.exportType = exportType

            this.exportReport()
        },
        exportModalClose() {
            this.exportModal = false
        },
        saveSchedule() {
            const reportId = _.get(this.selectedReport, "id")

            if (!reportId) {
                return
            }

            const endpoint = `/api/report/schedule/${reportId}/save`

            this.ajax
                .post(endpoint, {
                    settings: this.recurrenceSettings,
                })
                .then(({data}) => {
                    this.scheduleReport = false
                    this.selectedReport = data
                    const reportIndex = this.reports.findIndex((report) => report.report_key == this.selectedReport.report_key)
                    this.reports[reportIndex] = this.selectedReport
                    this.$notify({
                        type: "success",
                        customClass: "report-notification",
                        title: `Schedule Saved`,
                        message: "This schedule has been saved successfully",
                        position: "bottom-right",
                    })
                })
        },
        deleteSchedule() {
            const reportId = _.get(this.selectedReport, "id")

            if (!reportId) {
                return
            }

            swal({
                title: "Are you sure?",
                text: `You are about to delete this schedule, are you sure you want to do that?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#c1c1c1",
                confirmButtonText: "Delete",
                confirmButtonColor: "#d33",
                reverseButtons: false,
            }).then((actioned) => {
                if (actioned.value) {
                    this.ajax.get(`/api/report/schedule/${reportId}/delete`).then(({data}) => {
                        this.scheduleReport = false
                        this.selectedReport = data
                        const reportIndex = this.reports.findIndex((report) => report.id == this.selectedReport.id)
                        this.reports[reportIndex] = this.selectedReport
                        this.recurrenceSettings = Object.assign({}, this.defaultRecurrenceSettings)
                        this.$notify({
                            type: "success",
                            customClass: "report-notification",
                            title: `Schedule Deleted`,
                            message: "This schedule has been deleted successfully",
                            position: "bottom-right",
                        })
                    })
                }
            })
        },
        collapseClick() {
            this.collapseTags = !this.collapseTags
        },
        exportReport() {
            const endpoint = "/api/report/export" + (this.selectedReport ? "/" + this.selectedReport.id : "")
            this.exporting = true

            this.ajax
                .post(endpoint, {
                    columns: this.columns.length ? this.columns : null,
                    selected: this.selectedColumns,
                    selectedColumns: _.keyBy(
                        this.columns.filter((col) => this.selectedColumns.includes(col.prop)),
                        "prop"
                    ),
                    dateRange: this.dateRange,
                    dateRangeSelect: this.dateRangeSelect,
                    dateField: this.dateField,
                    sortField: this.sortField,
                    sortOrder: this.sortOrder,
                    reportState: this.tenantFilters.state,
                    excludeGst: this.excludeGst,
                    page: this.page,
                    reportId: _.get(this.selectedReport, "id"),
                    reportName: this.reportName,
                    reportDescription: this.reportDescription,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    exportType: this.exportType,
                    showSummary: this.showSummary,
                    count: this.totalApps
                })
                .then(({data}) => {
                    if (data.exportFilePath) {
                        window.location = data.exportFilePath
                        this.exportModalClose()
                    }

                    if (data.message) {
                        this.$message({
                                showClose: true,
                                duration: 0,
                                message: data.message,
                                type: "success"
                        });
                        this.exportModalClose();
                    }

                })
                .finally(() => {
                    this.exporting = false
                    this.showSummary = true;
                })
        },
        deleteReport() {
            swal({
                title: "Are you sure?",
                text: `You are about to delete this report, are you sure you want to do that?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#c1c1c1",
                confirmButtonText: "Delete",
                confirmButtonColor: "#d33",
                reverseButtons: false,
            }).then((actioned) => {
                if (actioned.value) {
                    this.hideReportSettingsForm()
                    this.ajax.get(`/api/report/delete/${this.selectedReport.id}/`).then(({data}) => {
                        this.clearReport()
                        this.reports = data.reports
                    })
                }
            })
        },

        clearReport() {
            this.tableData = []
            this.columns = []
            this.selectedColumns = []
            this.orderedColumns = []
            this.optionsSelected = []
            this.summary = null
            this.from = 1
            this.to = 0
            this.total = 0
            this.reportId = false
            this.selectedReport = null
            this.reportName = null
            this.reportDescription = null
            this.dateField = "history.activity"
            this.dateRange = null
            this.dateRangeSelect = "This Month"
            this.sortField = null
            this.sortOrder = null
            this.recurrenceSettings = null
            this.state = null
            this.reportChanged()
        },

        saveReport() {
            const endpoint = "/api/report/save"

            this.ajax
                .post(endpoint, {
                    columns: this.columns.length ? this.columns : null,
                    selected: this.selectedColumns,
                    selectedColumns: _.keyBy(
                        this.columns.filter((col) => this.selectedColumns.includes(col.prop)),
                        "prop"
                    ),
                    dateRange: this.dateRange,
                    dateRangeSelect: this.dateRangeSelect,
                    dateField: this.dateField,
                    sortField: this.sortField,
                    sortOrder: this.sortOrder,
                    excludeGst: this.excludeGst,
                    page: this.page,
                    reportId: this.selectedReport.id,
                    reportName: this.reportName,
                    reportDescription: this.reportDescription,

                })
                .then(({data}) => {
                    this.reportId = data.report.id
                    this.selectedReport = data.report
                    this.reportName = data.report.name
                    this.reportDescription = data.report.description
                    this.reports = data.reports
                    this.recurrenceSettings = this.defaultRecurrenceSettings
                })
        },

        loadReport() {
            if (!this.selectedReport) return

            this.tableData = [[]]

            var selectedColumnNames = this.selectedReport.configuration.selected

            // clear custom fields
            this.options = this.options.filter((optionGroup) => _.get(optionGroup, "label") != "Custom Fields")

            let definedColumnNames = _.intersection(
                this.options.flatMap((group) => group.children).map((c) => c.label),
                selectedColumnNames
            )
            let customColumnNames = _.difference(selectedColumnNames, definedColumnNames)

            if (customColumnNames.length) {
                this.options.push({
                    label: "Custom Fields",
                    value: "Custom Fields",
                    children: customColumnNames.map((colName) => {
                        return {
                            label: colName,
                            value: colName,
                        }
                    }),
                })
            }

            this.optionsSelected = _.intersection(
                this.options.flatMap((group) => group.children).map((c) => c.label),
                selectedColumnNames
            )

            if (String(selectedColumnNames) == String(this.optionsSelected)) {
                this.orderedColumns = false
            } else {
                this.orderedColumns = selectedColumnNames
            }

            // combine report columns with default...
            let selectedColumns = _.get(this.selectedReport, "configuration.selectedColumns")
            if (!selectedColumns) {
                selectedColumns = this.selectedReport.configuration.columns.filter((col) =>
                    this.selectedColumns.includes(col.prop)
                )
            }
            let reportColumns = Object.values(selectedColumns)
            let allColumns = this.columns.map((col) =>
                Object.assign(
                    col,
                    {searchTerm: col.aggregate == "group" ? [] : ""},
                    reportColumns.find((rCol) => rCol.prop == col.prop)
                )
            )
            let newColumns = reportColumns.filter((rCol) => !this.columns.find((col) => col.prop == rCol.prop))
            allColumns = allColumns.concat(newColumns)
            this.columns = allColumns

            this.summary = false
            this.from = 1
            this.to = 0
            this.total = 0
            this.reportId = this.selectedReport.id
            this.reportName = this.selectedReport.name
            this.reportDescription = this.selectedReport.description
            this.dateField = this.selectedReport.configuration.dateField
            this.dateRange = this.selectedReport.configuration.dateRange
            this.dateRangeSelect = this.selectedReport.configuration.dateRangeSelect
            this.sortField = this.selectedReport.configuration.sortField
            this.sortOrder = this.selectedReport.configuration.sortOrder
            this.excludeGst = _.get(this.selectedReport, "configuration.excludeGst", false)

            if (_.get(this.selectedReport, "schedules", []).length) {
                let firstSchedule = _.get(this.selectedReport, "schedules", []).find((sch) => sch)
                this.recurrenceSettings = _.assign({}, firstSchedule.settings, {
                    scheduleUsers: _.map(firstSchedule.users, (user) => user.user),
                })
            } else {
                this.recurrenceSettings = Object.assign({}, this.defaultRecurrenceSettings)
            }

            if (this.sortField && this.sortOrder) {
                this.$refs.reportBuilderTable.sort(this.sortField, this.sortOrder)
                this.$nextTick(() => {
                    let sortColumnClass = this.$refs.reportBuilderTable.columns.find((col) => col.property == this.sortField)
                    if (sortColumnClass) {
                        $(`.${sortColumnClass.id}.is-leaf:not(.${this.sortOrder}) .sort-caret.${this.sortOrder}`).first().click()
                    }
                })
            } else {
                this.reportChanged()
            }

            this.$nextTick(() => {
                $(".report-builder-table .el-table__body, .report-builder-table .el-table__fixed-body-wrapper").hide()
                this.handleResize()
            })
        },

        showReportSettingsForm() {
            this.editReportModal = true
            this.loadSettings()
        },

        hideReportSettingsForm() {
            this.editReportModal = false
            this.clearSettings()
        },

        loadSettings() {
            this.reportSettingsForm.name = this.reportName
            this.reportSettingsForm.description = this.reportDescription
            this.reportSettingsForm.ownerId = _.get(this.selectedReport, "owner.id")
            this.reportSettingsForm.teamIds = _.get(this.selectedReport, "teams", []).map((t) => t.id)
            this.reportSettingsForm.userIds = _.get(this.selectedReport, "users", []).map((u) => u.id)
            this.reportSettingsForm.roles = _.get(this.selectedReport, "roles", []).map((r) => r.name)
            this.reportSettingsForm.hsEnabled = _.get(this.selectedReport, "hs_enabled", false) ? true : false
            if (_.isEmpty(this.reportSettingsForm.roles)) {
                this.reportSettingsForm.roles = ["administrator", "manager"]
            }

            this.loadReportUsers()
        },

        removeTeamTag(value) {
            if (!_.find(this.currentUser.teams, {id: value})) {
                this.reportSettingsForm.teamIds.push(value)
                return false
            }
        },

        clearSettings() {
            this.reportSettingsForm.name = ""
            this.reportSettingsForm.description = ""
            this.reportSettingsForm.ownerId = null
            this.reportSettingsForm.teamIds = []
            this.reportSettingsForm.userIds = []
            this.reportSettingsForm.roles = []
        },

        loadReportUsers() {
            this.$tenant.get("/api/v2/tenant-users").then((res) => {
                this.reportUsers = res.data
            })
        },

        filterReportUsers(roleName, restrict = true) {
            return this.reportUsers.filter(
                (user) =>
                    !!user.roles.filter(
                        (role) =>
                            (roleName === "all" || role.name === roleName) &&
                            (this.reportSettingsForm.roles.includes(role.name) || !restrict)
                    ).length &&
                    (!this.reportSettingsForm.teamIds.length ||
                        !!user.teams.filter((userTeam) => this.reportSettingsForm.teamIds.includes(userTeam.id)).length ||
                        !restrict)
            )
        },

        saveReportSettings() {
            this.$refs["reportSettingsForm"].validate((valid) => {
                if (valid) {
                    this.loadingReportSettings = true

                    const endpoint = "/api/report/settings/save"

                    this.ajax
                        .post(endpoint, {
                            reportId: this.selectedReport.id,
                            reportName: this.reportSettingsForm.name,
                            reportDescription: this.reportSettingsForm.description,
                            ownerId: this.reportSettingsForm.ownerId,
                            teamIds: this.reportSettingsForm.teamIds,
                            userIds: this.reportSettingsForm.userIds,
                            hsEnabled: this.reportSettingsForm.hsEnabled,
                            roles: this.reportSettingsForm.roles,
                        })
                        .then(({data}) => {
                            this.reportId = data.report.id
                            this.selectedReport = data.report
                            this.reportName = data.report.name
                            this.reportDescription = data.report.description
                            this.reports = data.reports
                            this.hideReportSettingsForm()
                        })
                        .finally(() => {
                            this.loadingReportSettings = false
                        })
                }
            })
        },

        setFieldsScrollable() {
            const slider = document.querySelectorAll(".el-form-item .el-form-item__content .el-checkbox-group .el-col")

            slider.forEach((elem) => {
                elem.addEventListener("mousewheel", (e) => {
                    e.preventDefault()
                    elem.scrollBy({
                        top: 0,
                        left: e.deltaY * 3,
                        behavior: "smooth",
                    })
                })
            })
        },

        getFilterValues: _.throttle(function (event, column) {
            this.filterLoading = true

            this.ajax
                .post("/api/report-filter", {
                    columns: this.columns.length ? this.columns : null,
                    selected: this.selectedColumns,
                    selectedColumns: _.keyBy(
                        this.columns.filter((col) => this.selectedColumns.includes(col.prop)),
                        "prop"
                    ),
                    dateRange: this.dateRange,
                    dateRangeSelect: this.dateRangeSelect,
                    dateField: this.dateField,
                    filterColumn: column,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                })
                .then(({data}) => {
                    this.$set(this.filters, column.prop, data)
                })
                .finally(() => {
                    this.filterLoading = false
                })
        }, 100),

        getSummaries(param) {
            const {columns, data} = param
            let sums = this.summary ? Object.values(this.summary) : []

            if (columns.length != this.reportColumns.length) {
                return sums
            }

            this.reportColumns.forEach((element, index) => {
                if (["group", "primary"].includes(element.aggregate)) {
                    sums[index] = ""
                } else {
                    sums[index] =
                        element.formatter && _.get(this.summary, element.prop, "")
                            ? element.formatter(null, null, this.summary[element.prop])
                            : _.get(this.summary, element.prop, "")
                }
            })

            if (this.from < this.to) {
                sums[0] = `Records ${this.from} to ${this.to}${
                    this.to < this.total ? " of " + this.formatter.number(null, null, this.total) : ""
                }`
            }
            return sums
        },

        reportSelectVisibleChange(visible) {
            this.reportSelectFilterable = visible
            if (visible) {
                this.$refs.reportSelect.$refs.reference.clear()
            }
        },

        filterSelectVisibleChange(visible, column) {
            if (visible) {
                this.filterSelectVisible = column
            } else if (this.filterSelectVisible == column) {
                this.filterSelectVisible = false
            }

            if (this.filterSelectDirty && !visible && this.filters) {
                _.unset(this.filters, column.prop)
                this.filterSelectDirty = false
            }
        },

        filterSelectChange(val, scope, column) {
            this.filterSelectDirty = true
            const columnIndex = this.columns.findIndex((col) => col.prop == column.prop)
            this.columns[columnIndex].searchTerm = val
            this.lazyReportChanged()
        },

        filterOperatorChange(val, column) {
            this.filterSelectChange(column.searchTerm, null, column)
        },

        changeHandler(e) {
            e.preventDefault()
        },

        infiniteHandler($state) {
            this.loading = true
            this.getData($state)
        },

        sortMethod: _.debounce(function (column) {
            this.sortField = column.prop
            this.sortOrder = column.order
            this.reportChanged()
        }, 300),

        selectedColumnsChange: _.debounce(function (val) {
            if (this.dateField == "history.activity" && this.reportContainsGroupedDate) {
                this.dateField = "history.lead"
            }
            this.handleResize()
            this.reportChanged()
        }, 1000),

        lazyReportChanged: _.debounce(function () {
            this.reportChanged()
        }, 1000),

        reportChanged() {
            if (!this.reportColumns.length && this.filterColumns) {
                return
            }

            this.$nextTick(function () {
                this.loading = true
                this.page = 1
                this.$refs.infiniteLoading.stateChanger.reset()
                this.$refs.reportBuilderTable.doLayout()
                this.getData(this.$refs.infiniteLoading.stateChanger)
                $(".report-builder-table:not(.filters) .el-table__body-wrapper.is-scrolling-right").scrollLeft(0)
            })
        },

        fieldRemoved(field) {
            if (field == this.sortField) {
                this.sortField = null
                this.sortOrder = null
            }
            this.handleResize()
        },

        handleResize: _.debounce(function () {
            let height = $("." + this.container).innerHeight() - $(".el-form").outerHeight()
            if (this.filterColumns.length) {
                height = height - 59
            }
            $(".report-builder > .el-table").height(height - 1)
            if (this.$refs.reportBuilderTable) {
                this.$refs.reportBuilderTable.doLayout()
            }
        }, 100),

        headerResize(newWidth, oldWidth, column, event) {
            this.columns.find((col) => column.property == col.prop).width = newWidth
        },

        getMaxHeight() {
            return $(".el-main").innerHeight() - $(".el-form").outerHeight() + "px"
        },

        onDragDrop(el, target, source, sibling) {
            this.drake.cancel()
            let tableColumns = this.$refs.reportBuilderTable.columns

            let sourceColumn = tableColumns.find((column) => column.id == _.get(el, "classList.0"))
            let sourceColumnIndex = this.selectedColumns.indexOf(sourceColumn.property)
            let sourceColumnConfig = this.columns[sourceColumnIndex]

            let targetColumn = tableColumns.find((column) => column.id == _.get(sibling, "classList.0"))
            let targetColumnIndex = targetColumn
                ? this.selectedColumns.indexOf(targetColumn.property)
                : this.selectedColumns.length

            // console.log(
            //     'move',
            //     sourceColumn.label,
            //     tableColumns.indexOf(sourceColumn),
            //     'to',
            //     targetColumn.label,
            //     tableColumns.indexOf(targetColumn),
            // );

            if (!this.orderedColumns.length) this.orderedColumns = this.selectedColumns

            this.orderedColumns.splice(sourceColumnIndex, 1)

            if (sourceColumnIndex < targetColumnIndex || targetColumnIndex >= this.orderedColumns.length)
                targetColumnIndex = targetColumnIndex - 1

            this.orderedColumns.splice(targetColumnIndex, 0, sourceColumn.property)
            this.optionsSelected = _.intersection(
                this.options.flatMap((group) => group.children).map((c) => c.label),
                this.orderedColumns
            )
        },

        addColumn(prop, label) {
            this.columns.unshift({
                field: prop,
                aggregate: "group",
                type: "string",
                prop: label,
                label: label,
                minWidth: 160,
                align: "left",
                headerAlign: "center",
                formatter: null,
                fixed: true,
            })
            this.getData()
        },

        getData: _.debounce(function ($state = null) {
            this.loading = true
            this.ajax
                .post("/api/report", {
                    state: _.get(this.tenantFilters, 'state', false),
                    bdms: _.get(this.tenantFilters, 'bdms', false),
                    selected: this.selectedColumns,
                    selectedColumns: _.keyBy(
                        this.columns.filter((col) => this.selectedColumns.includes(col.prop)),
                        "prop"
                    ),
                    dateField: this.dateField,
                    dateRange: this.dateRange,
                    dateRangeSelect: this.dateRangeSelect,
                    sortField: this.sortField,
                    sortOrder: this.sortOrder,
                    excludeGst: this.excludeGst,
                    page: this.page,
                    reportState: this.tenantFilters.state,
                    selectedReport: this.reportId,
                    reportName: this.reportName,
                    reportDescription: this.reportDescription,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                })
                .then(({data}) => {

                    // push custom fields into the column group
                    if (!_.isEmpty(data.customFields)) {
                        data.customFields.forEach(customField => {
                            let fields = Object.entries(customField.keys).map(key => {
                                return `${key[1]} (cf_${customField.uuid}_${key[0]})`
                            })
                            this.columnGroups.push({
                                name: `${customField.name} Custom Fields`,
                                fields: fields
                            })
                        })
                    }

                    let newFilters = []
                    if (this.filterSelectVisible && this.filters) {
                        newFilters[this.filterSelectVisible.prop] = this.filters[this.filterSelectVisible.prop]
                        this.filters = newFilters
                    } else {
                        this.filters = []
                    }

                    if (_.get(data, "settings.fields")) {
                        this.columns = Object.entries(data.settings.fields).map(([label, config]) => ({
                            field: config.field,
                            aggregate: config.aggregate,
                            type: config.type,
                            dataType: config.dataType || null,
                            dateField: config.dateField || null,
                            decimalPlaces: config.decimalPlaces || null,
                            dateFormat: config.dateFormat || null,
                            orderBy: config.orderBy || null,
                            orderByType: config.orderByType || null,
                            orderDateFormat: config.orderDateFormat || null,
                            fixedDate: config.fixedDate || null,
                            filter: config.filter || null,
                            filterOperator: config.filterOperator || "=",
                            gst: config.gst || null,
                            hasGstField: config.hasGstField || null,
                            prop: label,
                            label: label,
                            headerAlign: "center",
                            align: ["string", "date"].includes(config.type) ? "left" : "right",
                            width: config.width || 140,
                            formatter: config.type == "decimal" ? this.formatter.currency : _.get(this.formatter, config.type),
                            searchTerm: config.searchTerm ? config.searchTerm : config.aggregate == "group" ? [] : "",
                        }))

                        if (!this.options.length) {
                            this.options = this.columnGroups.map((columnGroup) => {
                                return {
                                    value: columnGroup.name,
                                    label: columnGroup.name,
                                    children: columnGroup.fields
                                        .map((columnName) => {
                                            if (!this.columns.find((col) => col.prop == columnName)) return null
                                            return {
                                                value: columnName,
                                                label: columnName,
                                            }
                                        })
                                        .filter((e) => e),
                                }
                            })
                        }
                    }

                    if (data.current_page == 1) {
                        this.tableData = Object.values(data.data)
                    } else {
                        this.tableData = this.tableData.concat(Object.values(data.data))
                    }

                    this.summary = data.summary ? data.summary : this.summary
                    this.from = 1
                    this.to = data.to
                    this.total = data.total

                    this.reports = data.reports ? data.reports : this.reports
                    this.selectedReport = this.reports.find((r) => r.id == this.reportId)
                    this.reportName = data.reportName ? data.reportName : this.reportName
                    this.reportDescription = data.reportDescription ? data.reportDescription : this.reportDescription

                    $(".report-builder-table .el-table__body, .report-builder-table .el-table__fixed-body-wrapper").show()

                    if (data.current_page < data.last_page && data.data.length >= data.per_page) {
                        $state.loaded()
                        this.page = data.current_page + 1
                    } else {
                        $state.complete()
                    }
                })
                .catch(() => {
                    $state.complete()
                })
                .finally(() => {
                    $(".report-builder-table .el-table__body, .report-builder-table .el-table__fixed-body-wrapper").show()
                    this.loading = false
                    this.$nextTick(() => {
                        this.handleResize()
                        // this.$refs.reportBuilderTable.doLayout();
                        $(".report-builder-table:not(.filters) .el-table__body-wrapper").first().attr("tabindex", -1).focus()
                    })
                })
        }, 300),
    },
}
</script>

<style lang="scss" scoped>
/* theme color */
// $--color-primary: teal;

// /* icon font path, required */
// $--font-path: '~element-ui/lib/theme-chalk/fonts';

// @import "~element-ui/packages/theme-chalk/src/index";

@import url("https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;500&display=swap");

.alert.logged-in-as {
    display: none !important;
}

.report-columns-cascader {
    .el-cascader-panel .el-cascader-menu {
        font-size: 11px;

        .el-cascader-menu__wrap {
            height: auto;
            max-height: 450px;

            .el-cascader-node {
                padding: 0 25px 0 15px;
                height: 30px;
                line-height: 29px;

                &.in-active-path,
                &.is-active,
                &.is-selectable.in-checked-path {
                    font-weight: 500;
                }
            }
        }

        &:first-child .el-checkbox {
            pointer-events: none;
        }
    }
}

.header-filter-popper {
    * {
        font-family: "Roboto Mono", "Poppins" !important;
        letter-spacing: -0.1px;
    }

    .el-radio-group {
        display: table;
    }
}

.report-builder {
    overflow: hidden;
    background: #fbfbfb;

    .font-11,
    .el-input,
    .el-select,
    .el-tag {
        font-size: 11px;
    }

    /** checkbox */
    .el-checkbox {
        &.exclude_gst {
            padding-left: 5px;
        }

        .el-checkbox__label {
            font-size: 11px;
        }
    }

    /** radio */
    .el-radio-group {
        display: table;
    }

    /** cascader */
    .el-cascader {
        font-size: 11px !important;

        .el-cascader__tags {
            top: 3px;
            -webkit-transform: unset;
            transform: unset;
        }
    }

    .recurrence-editor-container .el-select__tags {
        top: 6px;
        -webkit-transform: unset;
        transform: unset;
    }

    /** date picker */
    .el-date-editor--daterange.el-input__inner {
        width: 230px;
    }

    /** table */
    .report-builder-table {
        input {
            font-family: "Roboto Mono", "Poppins" !important;

            &::placeholder {
                letter-spacing: -0.75px;
            }
        }

        .cell {
            font-family: "Roboto Mono", "Poppins" !important;
            letter-spacing: -0.1px;
        }

        .collapsed {
            .el-tag:first-child {
                overflow: hidden !important;
                text-overflow: ellipsis;
            }

            .el-select__tags {
                -ms-flex-wrap: nowrap !important;
                flex-wrap: nowrap !important;
            }
        }

        &.filters {
            &:after,
            &:before {
                display: none;
            }

            th.is-leaf {
                border-top: 1px solid #ebeef5;
                border-bottom: none;
            }
        }

        th.is-leaf {
            &:first-child .cell {
                padding-left: 0px;
            }
        }

        .el-table__fixed {
            .el-table__fixed-header-wrapper {
                z-index: 4;
            }

            .el-table__fixed-body-wrapper {
                top: 59px !important;
            }
        }

        .el-table__fixed,
        .el-table__fixed-body-wrapper,
        .el-table__body-wrapper {
            transition: height 0.3s ease-out;
        }

        .el-table__footer-wrapper .cell:first-child {
            white-space: nowrap;
        }

        .report-builder-table .el-table__footer-wrapper tr td:first-child {
            text-align: left;
        }
    }
}

.report-builder-table {
    border-left: none;
    font-size: 11px;

    .el-table {
        font-size: 11px;

        .el-link--inner {
            font-size: 11px;
        }

        .el-table__row.expanded.sticky td {
            background-color: #fafafa;
        }

        tr {
            height: 47px;
        }
    }

    .el-loading-mask {
        opacity: 0.6;
    }

    th.is-leaf {
        padding: 0;
        height: 59px;

        .cell {
            font-size: 11px;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0;
            text-transform: uppercase;
            color: #606266;
        }

        .header-handle {
            .cell {
                span {
                    max-width: calc(100% - 10px);
                    display: block;
                    padding: 0 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .el-select__tags {
            -ms-flex-wrap: nowrap !important;
            flex-wrap: nowrap !important;
            overflow: hidden !important;
            max-width: calc(100% - 23px) !important;

            .el-tag:first-child {
                overflow: hidden !important;
                text-overflow: ellipsis;
            }

            .el-select__tags-text:empty::before {
                content: "Blank";
            }
        }
    }

    ::-webkit-scrollbar {
        width: 13px;
        height: 13px;
    }
}

.font-11 {
    font-size: 11px !important;
}

.is-leaf.gu-mirror {
    border-radius: 3px;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 900;
    display: flex;
    text-align: center;
    opacity: 0.8 !important;
    max-height: 40px !important;
    max-width: 220px !important;
}

.is-leaf.gu-mirror .cell {
    vertical-align: middle;
    margin-top: auto;
    margin-bottom: auto;
    width: 100%;
    font-family: "Roboto Mono";
    font-size: 11px;
    padding-top: 0px !important;
}

.is-leaf.gu-mirror .cell .header-filter {
    display: none;
}

.el-table__fixed,
.el-table__fixed-right {
    background-color: white;
}

.el-table--scrollable-x .el-table__fixed {
    background: rgba(255, 255, 255, 0.7);
}

.report-builder-table .el-table--scrollable-x .el-table__fixed-footer-wrapper tbody tr .is-left {
    top: 1px;
}

.report-builder-table .el-table__fixed-body-wrapper > * {
    margin-bottom: 80px;
}

.el-range-separator {
    width: 20px !important;
    text-transform: uppercase;
    font-size: 8px !important;
    font-weight: 500;
}

.report-builder .el-table .cell {
    line-height: 22px;
    min-height: 22px;
}

.report-builder .el-table .cell .el-link span {
    font-weight: 300;
    font-family: "Roboto Mono";
    font-size: 11px;
}

.report-builder-table thead th .cell .el-input__inner {
    border-radius: 0;
    border: none;
    text-align: center;
}

.report-builder-fields-container .el-select__tags-text,
.report-builder-fields-container .el-select__input,
.report-builder-table thead th .el-select__tags-text,
.report-builder-table thead th .el-select__input {
    font-size: 11px !important;
    text-transform: initial;
}

.report-builder-table th.is-leaf .caret-wrapper {
    top: 2px;
    right: 5px;
    position: absolute;
}

/** dirty */
.header-filter-popper *,
.report-builder-select-popper *,
.header-filter-popper .el-select-dropdown__empty,
.report-settings-select-popper * {
    font-size: 11px !important;
}

.report-settings-select-popper .el-select-group__title {
    font-size: 14px !important;
    color: #284da5 !important;
}

.report-builder-table .el-checkbox.el-checkbox--mini.is-bordered.is-checked {
    -webkit-box-shadow: 0 0.125rem 0.25rem #00000014 !important;
    box-shadow: 0 0.125rem 0.25rem #00000014 !important;
}

.report-builder-table .header-filter .el-select .el-input--suffix .el-input__inner {
    font-size: 11px !important;
}

.report-builder-table .header-filter .el-select .el-input--suffix .el-input__inner::placeholder {
    padding-left: 12.5px;
}

.el-range-editor--mini.el-input__inner {
    height: 29.5px !important;
}

.report-builder .el-form .el-input--mini .el-input__inner {
    height: 30px;
    line-height: 30px;
}

.report-builder .el-table__footer-wrapper .cell,
.report-builder .el-table__fixed-footer-wrapper .cell {
    font-weight: 900;
}

.report-builder .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #606266;
}

.report-builder .el-table .descending .sort-caret.descending {
    border-top-color: #606266;
}

.report-builder-select-popper .el-select-dropdown__empty {
    font-size: 11px !important;
}

.header-filter-operator span {
    font-size: 10px !important;
    line-height: 90%;
}

.report-builder-select-popper .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 2px 0 0 2px !important;
}

.report-builder-select-popper .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 2px 2px 0 !important;
}

.report-builder-select-popper .el-radio-button__inner {
    padding: 7px 7px;
}

.report-builder-table thead th .cell .el-input__inner {
    font-size: 11px !important;
    font-weight: normal;
    text-align: left;
    padding: 0 10px;
}

.report-builder-table thead th .cell .el-input__inner::placeholder {
    font-size: 11px !important;
    text-align: center;
}

.report-builder-table thead th .cell .el-select .el-input__inner::placeholder {
    padding-right: 14px;
}

.report-builder-select-popper .el-select-dropdown__wrap {
    max-height: min-content;
}

.el-input__suffix-inner {
    display: block;
}

.report-builder-popper .el-select-dropdown__wrap {
    max-height: 75vh;
}

.report-builder-popper .el-select-group__title {
    font-size: 12px !important;
    text-transform: uppercase;
    color: var(--secondary) !important;
    font-weight: 900 !important;
}

.report-builder-popper .el-select-dropdown__item {
    font-size: 11px !important;
}

.report-settings-editor-container {
    .el-form-item {
        margin-bottom: 10px;

        .el-form-item__label {
            padding-bottom: 0;
        }

        .el-form-item__content {
            .el-form-item__error {
                position: relative;
            }
        }
    }
}
</style>
